$(document).ready(function() {

  // Search feature
  $('.search-icon a, .close-search a, .open-search-bar').on('click', function(e) {
    e.preventDefault();
    $('.search-icon').toggleClass('open');
    $('#search-bar').toggleClass('open');
    $('#search-bar input').focus();
  });

  /**  Filter products feature */
  // Loop through products to get available colours
  var colours = [];
  $('.product-preview').each(function(i, e) {
    const elementColoursArr = $(this).attr('data-colour').split(',');
    colours = colours.concat(elementColoursArr);
  });
  const availableColours = [...new Set(colours)].filter(e =>  e);
  console.log(availableColours);
  for (let index = 0; index < availableColours.length; index++) {
    const colour = availableColours[index];
    $('.tag-filters-colour').append(`<li class="tag-filters__item tag-colour tag-colour-${colour}" data-type="colour"><span class="checkmark" style="background: ${colour};"></span><a href="#">${colour}</a></li>`);
  }

  $('.filter-bar').on('click', function(e) {
      $(this).toggleClass('open');
      $(this).siblings('.tag-filters').slideToggle();
  });

  $('.filter-selector').on('click', function(e) {
    $(this).toggleClass('open');
    $('.filter-content').toggleClass('open');
  });

  $('.tag-filters__item a').on('click', function(e) {
    // Clear
    $('.remove-item').removeClass('remove-item')
    $('.prepended-content').remove();

    const parentElement = $(this).closest('.filter');
    const listItem = e.target.closest('li');
    const filterType = $(listItem).attr('data-type');
    e.preventDefault();

    if ($(listItem).hasClass('clear') || $(listItem).hasClass('sale')) {
      $('.tag-filters__item').removeClass('active');
      $('.filter-bar, .tag-filters, .filter-content, .filter-selector').removeClass('open');
      $('.tag-filters').slideUp();
    } else {
      if (filterType === "price") {
        // Make it a single choice select, so remove other active classes
        if ($(listItem).hasClass("active")) {
          $(parentElement).find('.tag-filters__item').removeClass('active');
          $(listItem).addClass("active");
        } else {
          $(parentElement).find('.tag-filters__item').removeClass('active');
        }
        $(`.type-${filterType}`).remove();
      }
      $(listItem).toggleClass('active');
      $(parentElement).find('.filter-bar').removeClass('open');
      $(parentElement).find('.tag-filters').removeClass('open');
    }


    // Setup selected value variables
    let selectedSize = [];
    $(`[data-type=size].active`).each(function(i, e) {
      selectedSize.push($(this).find('a').text());
    });
    let selectedColour = [];
    $(`[data-type=colour].active`).each(function(i, e) {
      selectedColour.push($(this).find('a').text());
    });
    const activeSize = selectedSize.join(',');
    const activePrice = $(`[data-type=price].active`).text();
    const activeColours = selectedColour.join(',');
    const activeSale = $(listItem).hasClass('sale');

    // Change filter title
    $('.filter-bar-price').text("Price: " + activePrice);
    $('.filter-bar-size').text("Size: " + activeSize.replaceAll(',', ', '));
    $('.filter-bar-colour').text("Colour: " + activeColours.replaceAll(',', ', '));

    // Calculate price param to set
    let maxValue = 1000000;
    let minValue = 0;
    if ($("[data-type=price].active").attr('data-value-min') || $("[data-type=price].active").attr('data-value-max')) {
      maxValue = Number($(`[data-type=price].active`).attr('data-value-max')) || 1000000;
      minValue = Number($(`[data-type=price].active`).attr('data-value-min')) || 0;
    }

    // Loop through products and hide
    $('.product-preview').each(function(i, e) {
      $(this).addClass('remove-item');
      let pricePasses = false;
      let sizePasses = false;
      let colourPasses = false;
      let salePasses = false;

      // SIZE
      if (activeSize) {
        const activeSizeArr = activeSize.split(',');
        const elementSizeArr = $(this).attr('data-size').split(',');
        activeSizeArr.forEach(size => {
          elementSizeArr.forEach(elSize => {
            if (size === elSize) sizePasses = true;
          });
        });
      } else {
        sizePasses = true;
      }

      // PRICE
      if (activePrice) {
        let price = $(this).attr('data-price');
        price = Number(price.substring(1, price.length-3));
        if (price <= maxValue && price >= minValue) pricePasses = true;
      } else {
        pricePasses = true;
      }

      // Colours
      if (activeColours) {
        const activeColoursArr = activeColours.split(',');
        const elementColoursArr = $(this).attr('data-colour').split(',');
        activeColoursArr.forEach(colour => {
          elementColoursArr.forEach(elColour => {
            if (colour.toLocaleLowerCase() === elColour.toLocaleLowerCase()) colourPasses = true;
          });
        });
      } else {
        colourPasses = true;
      }

      // Sale
      if (activeSale) {
        if ($(this).attr('data-sale')) salePasses = true;
      } else {
        salePasses = true;
      }

      if (pricePasses && sizePasses && colourPasses && salePasses) $(this).removeClass('remove-item');
    })
    
    if ($('.product-preview:not(.remove-item)').length === 0) {
      $('#ajax-content .row').first().prepend('<div class="large-12 columns prepended-content"><p>There are no products in this view.</p></div>');
    }

    // $.ajax({
    //   url : e.target.href,
    //   type: 'GET',

    //   success: function(data){
    //     var result = $('<div />').append(data).find('#ajax-content').html();
    //     $('.loader').hide();
    //     $('#ajax-content').html(result);
    //     var filterSection = $('<div />').append(data).find('.filter-section').html();
    //     var newHrefs = [];
    //     $(filterSection).find('.tag-filters__item').each(function(i, e) {
    //       newHrefs.push($(this).find('a').attr('href'));
    //     });
    //     $('.tag-filters__item').each(function(i, e) {
    //       $(this).find('a').attr('href', newHrefs[i]);
    //     });
    //     $('.product-preview').each(function(i, e) {
    //       let price = $(this).attr('data-price');
    //       price = Number(price.substring(1, price.length-3));
    //       if (price > maxValue || price < minValue) $(this).addClass('remove-item');
    //     })
    //     if ($('.product-preview:not(.remove-item)').length === 0) $('#ajax-content .row').first().prepend('<div class="large-12 columns prepended-content"><p>There are no products in this view.</p></div>');
    //   }
    // });
  });
});